// Use only capabilities returned by the authenticated API, never local account
// names or unverified token claims. Legacy responses allow business previews only.
export function prepareAdminSettings(settings, identity) {
  if (settings.permissions) return settings;
  const permissions = identity?.capabilities?.administration;
  if (permissions) return { ...settings, permissions };
  const admin = identity?.capabilities?.adminSettings === true;
  return {
    ...settings,
    readOnly: true,
    writeStatus: 'locked',
    compatibilityNotice: 'The API is running an older Admin version. Business settings are read-only. Deploy the updated API, then sign out and sign in to load your full permissions.',
    permissions: {
      workspace: admin, managePolicy: admin, manageHcRouting: admin,
      manageNotifications: admin, viewAccess: false, viewSecurity: false,
      manageRoles: false, manageCcdApprovers: false,
    },
  };
}
